<template>
  <div class="page">
    <van-sticky>
      <van-nav-bar title="提现记录" left-arrow @click-left="goBack" />

      <van-dropdown-menu>
        <van-dropdown-item
          v-model="timeValue"
          @change="timeChange"
          :options="timeOption"
        />
      </van-dropdown-menu>
    </van-sticky>
    <div class="nav">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :error.sync="error"
          :finished="finished"
          error-text="请求失败，点击重新加载"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="card"
            v-for="(item, index) in list"
            :key="index"
            @click="seeDetails(item)"
          >
            <div class="header">
              <span class="left">提现账号主姓名：{{ item.nickname }}</span>
              <span class="right">{{ item.success? '已成功':'提现失败' }}</span>
            </div>
            <div class="content">
              <p>提现金额：￥{{ item.amount }}</p>
              <p>提现方式：{{ getMethodName(item.method) }}</p>
              <p>微信订单号码：{{ item.id }}</p>
            </div>
            <div class="card-bottom">
              <span>{{ formatDateTime(item.dateCreated) }}</span>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { recordList } from '@/api/gold-coin'
import { parseTime } from '@/utils'
import moment from 'moment'
export default {
  data() {
    return {
      timeValue: undefined,
      list: [],
      query: {
        currentPage: 1,
        pageSize: 10,
        startTime: undefined,
        endTime: undefined,
      },
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      timeOption: [
        { text: '本月', value: 0 },
        { text: '2020年', value: 1 },
        { text: '2019年', value: 2 },
      ],
    }
  },
  created() {
    this.getListTime()
  },
  methods: {
    onLoad() {
      this.loading = true
      recordList(this.query).then(({ data }) => {
        if (data.code === 200) {
          const total = data.data.page.totalCount
          this.list = this.list.concat(data.data.dataList)
          this.query.currentPage++
          this.loading = false
          // 数据全部加载完成

          if (this.list.length >= total) {
            this.finished = true
          }
        } else {
          this.error = true
          this.finished = true
        }
      })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      this.list = []
      this.query.currentPage = 1
      this.refreshing = false
      this.onLoad()
    },
    getTime(time) {
      return parseTime(time)
    },
    getListTime() {
      console.log('day', moment().year())
      let thisYear = moment().year()
      this.timeOption = []
      this.timeOption = [
        { text: '全部', value: undefined },
        { text: '本月', value: 0 },
        { text: '近三月', value: 1 },
      ]
      for (let i = thisYear; i >= 2020; i--) {
        this.timeOption.push({
          text: i + '年',
          value: i,
        })
      }
    },
    timeChange(val) {
      let startTime = moment().hours(0).minutes(0).seconds(0).milliseconds(0)
      let endTime = undefined
      if (val === undefined) {
        this.query.startTime = undefined
        this.query.endTime = undefined
      } else if (val === 0) {
        startTime = startTime.date(1)
        endTime = moment()
      } else if (val === 1) {
        startTime = startTime.subtract(2, 'month').date(1)
        endTime = moment()
      } else {
        startTime = startTime.year(val).month(0).date(1)
        endTime = moment()
          .year(val)
          .date(31)
          .hours(23)
          .minutes(59)
          .seconds(59)
          .milliseconds(0)
      }

      if (val !== undefined) {
        this.query.startTime = startTime.format('x')
        this.query.endTime = endTime.format('x')
      }

      this.query.currentPage = 1
      this.list = []
      this.finished = false
      this.onLoad()
    },
    formatDateTime(inputTime) {
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' '+ h + ':' + minute + ':' + second;
},
    seeDetails(item) {
      if (!item.success ) {
        this.$router.push({
          path: '/gold-coin/withdraw-process',
          query: {
            amount: item.amount,
            nickname: item.nickname,
            reason: item.reason,
          },
        })
      }
    },
    // 0:待处理, 1:待后台处理, 2:拒绝, 3:待提现供应商处理, 4已完成
    getStatusName(num) {
      switch (num) {
        case 0:
          return '提现失败'
        case 1:
          return '提现成功'
      }
    },
    getMethodName(num) {
      switch (num) {
        case 0:
          return '微信'
      }
    },
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f4f4f4;
}
.nav {
  padding: 10px;
}
.card {
  margin-bottom: 10px;
  background: #fff;
  padding: 12px;
  .header {
    display: flex;
    justify-content: space-between;
  }
}
.left {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 11px;
  color: #323233;
}
.right {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 11px;
  color: #985d1f;
}
.content {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 11px;
  color: #323233;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebedf0;
  p {
    margin: 10px 0;
  }
}
.card-bottom {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 11px;
  color: #969799;
  padding-top: 8px;
}
</style>